// extracted by mini-css-extract-plugin
export var animate = "MobileNavPanel-module--animate--b2ed1";
export var fadeInAnimation = "MobileNavPanel-module--fadeInAnimation--9dc0f";
export var itemWrapper = "MobileNavPanel-module--itemWrapper--eef68";
export var panelItem = "MobileNavPanel-module--panelItem--99e58";
export var switcher = "MobileNavPanel-module--switcher--94b7d";